import { EmailTemplateDeleteModal } from "@/components/modals/email-template-delete-modal";
import { useHandlerDeletePrompt } from "@/components/modules/email-templates-sidebar/hooks";
import { useEmailTemplatesContext } from "@/components/modules/email-templates-sidebar/context";

export const PromptDeleteModal = () => {
  const { activeTemplate } = useEmailTemplatesContext();
  const { handlerOnConfirm } = useHandlerDeletePrompt();

  return (
    <>
      <EmailTemplateDeleteModal
        onConfirm={handlerOnConfirm(activeTemplate?.id)}
      />
    </>
  );
};
